import { useState, useEffect } from "react";
import { getData } from "../../Services/apiService";
import { useTranslation } from "react-i18next";

export const useCoupoms = ({ idClient }) => {
    const [coupons, setCoupons] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
        if (!idClient) return;

        fetchCoupons();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idClient]);

    const fetchCoupons = async () => {
        setLoading(true);

        // Get the query string from the local storage
        let queryString = JSON.parse(localStorage.getItem("clients_coupons"));
        if (!queryString) {
            queryString = {
                page: 1,
                limit: 10,
                totalItems: 0,
                order: [{ field: "id", direction: "asc" }],
            };
            localStorage.setItem(
                "clients_coupons",
                JSON.stringify(queryString)
            );
        }

        // Get the licenses for the client
        let uri = `/client/${idClient}/coupon?page=${queryString.page}&limit=${queryString.limit}`;

        // Adicionar ordenações à URI
        const orderString = encodeURIComponent(
            JSON.stringify(queryString.order)
        );

        uri += `&order=${orderString}`; // Add order to URI

        try {
            // Await the response
            const response = await getData(uri);

            if (response.status === 200) {
                // If there is no data, set coupons to empty array
                if (!response.body.data) {
                    setCoupons([]);
                    setLoading(false);
                    return;
                }

                const data = response.body.data.map((coupon) => {
                    return {
                        ...coupon,
                        days_use_label: setLabelDaysUse(coupon.days_use),
                    };
                });

                setCoupons(data);
                queryString.lastPage = response.body.total_pages || 1;
                queryString.totalItems = response.body.total_items || 0;
                localStorage.setItem(
                    "clients_coupons",
                    JSON.stringify(queryString)
                );
                setLoading(false);
                return;
            }

            console.error("Error fetching coupon values:", response.body);
        } catch (error) {
            console.error("Error fetching coupon values:", error);
        } finally {
            setLoading(false);
        }
    };

    const setLabelDaysUse = (daysUse) => {
        let label = "";
        const days = daysUse.split(",");

        for (let i = 0; i < days.length; i++) {
            const day = days[i];
            switch (day) {
                case "0":
                    label += t("date.days.everyday") + "  ";
                    break;
                case "1":
                    label += t("date.days.monday") + "  ";
                    break;
                case "2":
                    label += t("date.days.tuesday") + "  ";
                    break;
                case "3":
                    label += t("date.days.wednesday") + "  ";
                    break;
                case "4":
                    label += t("date.days.thursday") + "  ";
                    break;
                case "5":
                    label += t("date.days.friday") + "  ";
                    break;
                case "6":
                    label += t("date.days.saturday") + "  ";
                    break;
                case "7":
                    label += t("date.days.sunday") + "  ";
                    break;
                default:
                    break;
            }

            if (day !== "0" && i < days.length - 1) label = label.replace("  ", ", ");
        }

        return label.trim();
    };

    return { coupons, loading, fetchCoupons };
};
